import { getColor } from 'common/constants/_colors';
import { SPACES } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';

export const WidgetWrapper = styled(Flex)`
  border-radius: 5px;
  padding: ${SPACES.medium};
  border: ${({ border }) => border || `1px solid ${getColor('catskillWhite')}`};
  ${({ height }) => (height ? `height: ${height};` : '')}
  ${({ cursor }) => (cursor ? `cursor: ${cursor};` : '')}
  ${({ hover }) =>
    hover
      ? `background-color: ${getColor('catskillWhite', 0.4)};`
      : `background-color: ${getColor('white')};`}
  ${({ isEditable }) =>
    isEditable
      ? `:hover {
    -webkit-box-shadow: 0px 0px 11px 5px #ebeef5;
    box-shadow: 0px 0px 11px 5px #ebeef5;
  }`
      : ''}
`;
